import { useOrderCommonInfo } from './addMoreProductsModal.hook'

export const withOrderCommonInfo = (WrappedComponent: React.ComponentType) => {
  const displayName =
    WrappedComponent.displayName || WrappedComponent.name || 'Component'

  const ComponentWithOrderCommonInfo = (props: any): JSX.Element => {
    const { orderIds } = props
    const { orderCommonInfo, loadingOrderCommonInfo } =
      useOrderCommonInfo(orderIds)
    return (
      <WrappedComponent
        orderCommonInfo={orderCommonInfo}
        loadingOrderCommonInfo={loadingOrderCommonInfo}
        {...props}
      />
    )
  }
  ComponentWithOrderCommonInfo.displayName = `withOrderCommonInfo(${displayName})`

  return ComponentWithOrderCommonInfo
}
